/**
 * المرحلة 1.4 — a visit's state as a chip: open, closed and signed, or
 * amended after closing. Its own file so the live view and the list draw it
 * without pulling the whole visit page into their chunk.
 */

import { Icon } from '../../components/common';
import { useI18n } from '../../i18n/I18nProvider';

export function EncounterStatus({ status }) {
  const { t } = useI18n();
  const icon = status === 'open' ? 'clock' : status === 'amended' ? 'history' : 'lock';
  return (
    <span className={`enc-status is-${status}`} data-testid="encounter-status">
      <Icon name={icon} size={13} />
      {t(`encounter.status.${status}`)}
    </span>
  );
}

export default EncounterStatus;
